import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeSwitchButtons extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    select;
}
